import React from "react";
import Card from "react-bootstrap/Card";
import IconHome from "../../../styles/icons/IconHome";
import { SearchItem } from "../../../slices/leads/types";
interface SocialCardProps {
  post: SearchItem;
}

const SocialCard: React.FC<SocialCardProps> = ({ post }) => {
  const headerGenerator = (url: string): string => {
    const urlParts = url.split(".")[1];
    return urlParts;
  };

  return (
    <>
      {post && post.link && (
        <Card
          border="primary"
          style={{ borderColor: "violet" }}
          className="mb-3"
        >
          <Card.Header>{headerGenerator(post.link)}</Card.Header>
          <Card.Body>
            <Card.Title>{post.title}</Card.Title>
            <Card.Text>
              <p>
                {post.snippet}
                <br />
                URL:{" "}
                <a href={post.link} target="_blank" rel="noopener noreferrer">
                  {post.displayLink}
                </a>
              </p>
              <IconHome
                breadcrumb={headerGenerator(post.link)}
                activeColor={"null"}
              />
            </Card.Text>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default SocialCard;
